<ng-container *ngIf="configValue">
    <span
        class="material-symbols-rounded close"
        aria-label="Close"
        *ngIf="configValue.dismissable"
        tabindex="0"
        (keyup.enter)="dismiss()"
        (click)="dismiss()"
    >
        close
    </span>
    <div class="alert-content">
        <h4 *ngIf="title">
            <span class="material-symbols-rounded" aria-hidden="true"> {{ icon }} </span>
            {{ title }}
        </h4>
        <p *ngIf="message">
            {{ message }}
        </p>
    </div>
    <div #progressBar class="progress-bar" [ngClass]="toastClass"></div>
</ng-container>
